import { h, render, Component } from 'preact';
import { Suspense, lazy } from 'preact/compat';
import { IntlProvider } from 'preact-i18n';
import {WidgetHelper} from '../widgets/utils/widgetHelper';
import {GetWidgetComponent} from '../utils/widgetUtil';
import { SetBaseUrl } from '../utils/ApiUtil';
import { TranslationUtil } from '../utils/TranslationUtil';

export default class WidgetLoader extends Component {
    constructor(props) {
        super(props);
            this.state = {
            params: WidgetHelper.GetParams(),
            definition: {},
            showWidget: true,
            widgetLoaded: false,
            exception: false
        }
        if(window.location && window.location.href) {
            if(window.location.href.indexOf("browse.live") > -1 || window.location.href.indexOf("localhost:4000") > -1) {
              SetBaseUrl(true);
            }
            if(window.location.href.indexOf("search.blur.live") > -1) {
                SetBaseUrl(false);
            }
        }
    }
    componentDidMount() {
        WidgetHelper.RegisterForParamUpdate((e) => {
            this.getSetParams();
        }, false);
        this.getSetParams();
    }
    componentDidCatch(error, info) {
        //TODO send these errors to server
        let url = window.location.href;
        if(url && url.indexOf("testflag=true") > -1) {
            console.error(`Error loading widget "${this.props.name}"`);
            console.error(`Error details`, error);
            console.error(`Information`, info);
        }
        this.setState(c => {
            c.exception = true;
            return c;
        })
        this.setWidgetDisplay(false);
    }
    getSetParams() {
        //[TODO] validate the variables
        let params = WidgetHelper.GetParams();
        //set the translation definitions
        TranslationUtil.GetDefinition(WidgetHelper.GetParam("translang"), "widget").then(resp => {
            this.setState(c => {
                c.params = params;
                c.definition = resp;
                return c;
            })
        })
    }
    setWidgetDisplay(show) {
        if(this.props.setWidgetProp) {
            this.props.setWidgetProp(this.props.name, "hide", !show);
        }
    }
    setWidgetLoaded(isLoaded) {
        if(this.props.setWidgetProp) {
            this.props.setWidgetProp(this.props.name, "isLoaded", isLoaded);
        }
    }
    render () {
        const WidgetComponent = GetWidgetComponent(this.props.name);
        if(!WidgetComponent || WidgetComponent === null || this.state.exception === true) {
            return ("");
        }
        return (
            <div className="widgetBlock">
                <IntlProvider definition={this.state.definition}>
                    <Suspense fallback={<div>loading...</div>}>
                        <WidgetComponent 
                            {...this.props} 
                            {...this.state.params} 
                            definition={this.state.definition}
                            setWidgetDisplay={this.setWidgetDisplay.bind(this)}
                            setWidgetLoaded={this.setWidgetLoaded.bind(this)}
                        />
                    </Suspense>
                </IntlProvider>
            </div>
        );
    } 
}